export const CSPM_CONSTANTS = {
  title: "CSPM from OneMind includes: ",
  list: [
    "Real-time risk assessment for cloud-native resources",
    "Mapping against CIS, NIST, ISO 27001 frameworks",
    "Centralized multi-cloud compliance dashboard",
    "One-click or automated remediation paths",
  ],
};
